<template>
  <div style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class="d-flex flex-row align-baseline">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>Special Orders By Supplier</h1>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
          <v-select
            style="max-width: 250px;"
            :items="specialOrderStatuses"
            dense
            label="Status"
            outlined
            class="mt-4 mx-2"
            v-model="filters.status"
            @change="updateFilters"
          />
          <v-btn class="mx-2" color="info" @click="printBySupplierReport">Print</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div v-for="(supplier,index2) of data" :key="index2">
            <span v-if="supplier.items.length > 0">
            <!-- <span> -->
              <h2 class="mt-4 mb-2">{{ supplier.name }} [{{ supplier.id }}] </h2>
              <div v-for="(item,index3) of supplier.items" :key="index3" style="padding: 10px; border: 1px solid white;" class="d-flex flex-column">
                <span class="d-flex flex-row align-baseline justify-space-between">
                  <span>{{item.Customer.firstName}} {{ item.Customer.lastName }} -- (ITEM: {{ item.styleNo }} {{ item.colour }} {{ item.size }}) -- {{ item.customerRef?item.customerRef.toUpperCase():'' }} - {{ helpers.customFormatDate(item.dueAt, "notime").toUpperCase() }}</span> 
                  <span class="d-flex flex-row align-baseline">
                    <confirmedActionButton
                      v-if="getNextStatus() !== -1"
                      color="info"   
                      @cb="setSOItemStatus(item.specialOrderId,item.id, getNextStatus())"
                      :buttonText="getNextStatus()"
                      text
                      micro
                      :dialogText="'Are you sure you wish to proceed?'"
                    />
                    <v-btn color="info" text @click="goToSO(item.specialOrderId)">View SO</v-btn>
                    <span>SO# {{ item.specialOrderId }} -- [{{ supplier.id }}]</span>
                  </span>
                </span>
                <span>
                  <!-- <v-textarea v-if="item.notes" outlined disabled label="Notes" :value="item.notes"/> -->
                </span>
              </div>
              <v-divider/>
            </span>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters, mapMutations } from "vuex"
  import moment from "moment";
  import helpers from '../../plugins/helpers';
  import confirmedActionButton from '../../components/confirmedActionButton.vue';
  export default {
    components: {
      confirmedActionButton
    },
    data () {
      return {
        helpers: helpers,
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        snackObj: {
          color: '',
          text: ''
        },
        max25chars: v => v.length <= 25 || 'Input too long!',
        headers: [
          { text: "ID", align: "start", sortable: true, value: "id"},
          { text: 'Name', value: 'customerName' },
          { text: 'Status', value: 'status' },
        ],
        editMode: false,
        data: [],
        filters: {
          status: "NEW"
        },
        singular: "SpecialOrder",
        singularLower: "specialorder",
        plural: "SpecialOrders",
        pluralLower: "specialorders"
      }
    },
    async mounted(){
        try {
          await this.getAllData()
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
            this.loader = false;
        }
    },
    computed: {
      ...mapGetters(['getUser', 'getId', 'getToken', 'isAllowed', 'getEndpoint', 'specialOrderStatuses'])
    },
    methods: {
      ...mapMutations([
      ]),      
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      async goToSO(id){
        await this.$router.push({path: `/specialOrders/view/${id}`})
      },
      async updateFilters(){
        try {
          this.$route.params.status = this.filters.status

          await this.getAllData()
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
            this.loader = false;
        }
      },
      getNextStatus(){
        let currentStatusIndex = this.specialOrderStatuses.findIndex(x=>x === this.filters.status)
        if(!currentStatusIndex && currentStatusIndex !== 0) return -1
        if(currentStatusIndex === this.specialOrderStatuses.length -1) return -1
        return this.specialOrderStatuses[parseInt(currentStatusIndex)+1]
      },
      async printBySupplierReport(){
        try {

          let x = await axios.post(`${this.getEndpoint}/api/print/bySupplierReport/${this.filters.status}`)
          if(x.data.error) throw x.data.error
          let printWindow = open("","Printing")
          printWindow.document.open()
          printWindow.document.write(x.data.data.job.htmlToPrint)
          printWindow.document.close()
          printWindow.setTimeout(()=>{
            printWindow.print()
            printWindow.close()
          },500)
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
            this.loader = false;
        }
      },
      async getAllData(){
        try {
          if(this.$route.params.status){
            this.filters.status = this.$route.params.status
          }
          
          let res = await axios.get(`${this.getEndpoint}/api/specialOrders/bySupplier/${this.filters.status}`)
          this.data = res.data
          
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
            this.loader = false;
        }
      },
      async setSOItemStatus(soId, itemId, nextStatus){
        try {
          let obj = {
            status: nextStatus
          }
          await axios.post(`${this.getEndpoint}/api/specialOrders/updateSoftItemStatus/${soId}/${itemId}`, obj)
          await this.getAllData()
          
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
            this.loader = false;
        }
      },
      momentDateFormat (date) {
        return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
      },
      parseISODate(date){
        return (date?new Date(date).toISOString().substring(0, 10):null);
      },
    }
  }
</script>
